<template>
  <div class='dialog-main'>
    <div class='bg-black'></div>
    <div class='Popup' @click.self="close">
      <div class='Popup1'>
        <div class='p_title'>提示</div>
        <div class='p_content'>
          <div class='err_or_right'>
            <div class='close-icon error'><i class="iconfont icon-icon_wrong"></i></div>
            <span v-if="Number(limitCount) > 0">买号异常，暂时无法购买商品。剩余 <span class="t_f23030">{{limitCount}}</span> 天恢复正常，请恢复正常后再购买。</span>
            <span v-else>买号异常，无法购买商品。如有疑问，请联系客服</span>
          </div>
        </div>
        <div class='p_content-btm'>
          <div class="p_content-btn w_50 sure" @click="close">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    limitCount: {
      type: Number,
      require: true,
      default: 0
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .bg-black{
    width: 100%;
    height: 100%;
    position: fixed;
    background: #000;
    opacity: 0.5;
    top: 0;
    left: 0;
    z-index: 900;
  }
  .Popup{
    position:fixed;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
    z-index: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: dialogAnim .2s ease-in;
    animation-fill-mode: backwards;
  }
  .Popup1{
    width: 80%;
    background: #fff;
    border-radius: 4px;
    padding: 15px 0 0;
  }
  .p_title{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .p_content{
    padding: 0 20px;
    margin: 15px 0 0 0;
    font-size: 15px;
  }
  .err_or_right{
    display: flex;
    margin-bottom: 30px;
    overflow: hidden;
  }
  .err_or_right .close-icon{
    margin-right: 10px;
    display: block;
    flex-shrink: 0;
    float: left;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
  }
  .close-icon .iconfont{font-size: 12px;vertical-align: middle;}
  .err_or_right .error{
    background: #f23030;
  }
  .err_or_right .success{
    background: #09BB07;
  }
  .p_content-btm{
    display: flex;
    align-items: center;
    height: 45px;
    margin-top: 10px;
    line-height: 45px;
    font-size: 15px;
    text-align: center;
    border-top: 1px solid #eee;
  }
  .p_content-btm .p_content-btn{
    flex-grow: 1;
  }
  .p_content-btm .sure{
    color: #108DF1;
    border-left: 1px solid #ddd;
  }
  .w_50{
    width: 50%;
  }
  .feedback-btn{
    color: #108DF1;
    cursor: pointer;
  }
  @keyframes dialogAnim{
    0%{
      opacity: 0;
      transform: scale(0.2);
    }
    100%{
      opacity: 1;
      transform: scale(1);
    }
  }
</style>
